import { ViewStateRecord } from '@common/data-models/records/viewstate-record';
import { ViewStateTypes } from "@common/enums/viewstate-types";
import { ObjectTypes } from "@common/enums/object-types";
import { ViewStateSequence } from '@common/data-models/navigation/viewstate-sequence';
import { ViewStateDelay } from '@common/data-models/navigation/viewstate-delay';
import { GlobalTablesService } from "@common/services/global-tables-service";
import { ViewStateDelaySerializer, ViewStateSequenceSerializer } from "@common/data-models/serializers/serializers";
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";

export class SlideshowViewStateRecord extends ViewStateRecord {

    public static DefaultSlideshowDelay: number = 5; // In seconds
    
    public initialize(viewstates?: Array<ViewStateRecord>) {
        this.viewStateType = ViewStateTypes.SLIDESHOW;
        super.initialize();

        this.viewStateSlideshowDelay = ViewStateDelaySerializer.Instance.initialize(PSTFieldNames.PSTViewStateSlideshowDelay);
        viewstates = viewstates || [];
        this.viewStateSlideshowSequence = ViewStateSequenceSerializer.Instance.initialize(viewstates);
    }

    public get viewStateSlideshowDelay(): ViewStateDelay {
        let delay = this.getAs<ViewStateDelay>("PSTViewStateSlideshowDelay");
        if (typeof delay.Value === 'undefined') delay.Value = SlideshowViewStateRecord.DefaultSlideshowDelay;
        return delay;
    }
    public set viewStateSlideshowDelay(value: ViewStateDelay) {
        this.set("PSTViewStateSlideshowDelay", value);
    }

    public get viewStateSlideshowSequence(): ViewStateSequence { return this.getAs<ViewStateSequence>("PSTViewStateSlideshowSequence"); }
    public set viewStateSlideshowSequence(value: ViewStateSequence) { this.set("PSTViewStateSlideshowSequence", value); }
}
